import React, { useContext } from 'react';
import { Routes, Route, Navigate, BrowserRouter } from 'react-router-dom';
import { privateRoutes, publikRoutes } from '../router/index';
import { AuthContext } from '../context/index';


const AppRouter = () => {
  const { isAuth } = useContext(AuthContext) || {};

  console.log('isAuth', isAuth)

  return (
    isAuth
      ?
      <BrowserRouter>
        <Routes>
          {privateRoutes.map(route =>
            <Route key={route.path} path={route.path} element={<route.component />} />
          )}
          <Route path="*" element={<Navigate to="/cabinet" />} />
        </Routes>
      </BrowserRouter>
      :
      <BrowserRouter>
        <Routes>
          {publikRoutes.map(route =>
            <Route key={route.path} path={route.path} element={<route.component />} />
          )}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </BrowserRouter>
  );
}

export default AppRouter;